import * as Yup from "yup"

export const FIELDS_NAME = {
   // DOWN_PAYMENT_PERCENTAGE: "percentage",
   STATUS: "status",
   FIXED_AMOUNT: "deposit",
   ORDER_PLACED_MSG: "orderPlacedMsg",
}

export const initialValues = {
   // [FIELDS_NAME.DOWN_PAYMENT_PERCENTAGE]: "",
   [FIELDS_NAME.STATUS]: "ACTIVE",
   [FIELDS_NAME.FIXED_AMOUNT]: 2000,
   [FIELDS_NAME.ORDER_PLACED_MSG]:
      "Thank you for submitting your trailer build, a member of our Casita Sales Team will reach out to you to complete your purchase",
}

export const validationSchema = Yup.object({
   // [FIELDS_NAME.DOWN_PAYMENT_PERCENTAGE]: Yup.number("Enter numbers only")
   //    .required("Enter percentage")
   //    .test(
   //       "is-valid-percentage",
   //       "Percentage must be between 1 and 100, and can include decimals (e.g., 8.55)",
   //       value => {
   //          if (!value) return false
   //          const num = parseFloat(value)
   //          const isInteger = Number.isInteger(num)

   //          return (
   //             (isInteger && num >= 1 && num <= 100) ||
   //             (!isInteger && num > 0 && num <= 100)
   //          )
   //       }
   //    ),

   [FIELDS_NAME.STATUS]: Yup.string().required("Select status"),
   [FIELDS_NAME.FIXED_AMOUNT]: Yup.number()
      .test("length-check", "Price must be between 1 and 8 digits", item => {
         let num = item?.toString()?.length
         return num <= 8 && num >= 1
      })
      .min(1, "Fixed deposit must be at least $1")
      .required("Enter fixed deposit amount"),
   [FIELDS_NAME.ORDER_PLACED_MSG]: Yup.string()
      .required("Enter order placed message")
      .test(
         "not-empty",
         "Order placed message cannot be empty",
         value => value && value.trim().length > 0
      ),
})
